import { z } from 'zod';
// Audio/video clip placed on a track.
export const createRegionSchema = z.object({
    mediaFileId: z.string().uuid(),
    startMs: z.number().int().min(0).default(0),
    durationMs: z.number().int().min(1),
    offsetMs: z.number().int().min(0).default(0),
    fadeInMs: z.number().int().min(0).default(0),
    fadeOutMs: z.number().int().min(0).default(0),
    gain: z.number().min(0).max(4).default(1.0),
    linkedRegionId: z.string().uuid().nullable().optional(),
});
export const updateRegionSchema = z.object({
    mediaFileId: z.string().uuid().optional(),
    startMs: z.number().int().min(0).optional(),
    durationMs: z.number().int().min(1).optional(),
    offsetMs: z.number().int().min(0).optional(),
    fadeInMs: z.number().int().min(0).optional(),
    fadeOutMs: z.number().int().min(0).optional(),
    gain: z.number().min(0).max(4).optional(),
    linkedRegionId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=region.schemas.js.map